export function humanBaseSize(bases: number): string {
  const thresh = 1000;
  if (Math.abs(bases) < thresh) {
    return `${bases}`;
  }
  const units = ["Kb", "Mb", "Gb"];
  let u = -1;
  do {
    bases /= thresh;
    ++u;
  } while (Math.abs(bases) >= thresh && u < units.length - 1);
  return bases.toFixed(1) + " " + units[u];
}

export function prettyFileSize(size: number): string {
  if (size === 0) {
    return "zero bytes";
  }
  if (size > 0 && size < 1e3) {
    return `${size} bytes`;
  } else if (size > 1e3 && size <= 1e6) {
    return `${(size / 1e3).toFixed(1)} kB`;
  } else if (size > 1e6 && size <= 1e9) {
    return `${(size / 1e6).toFixed(1)} MB`;
  } else if (size > 1e9) {
    return `${(size / 1e9).toFixed(1)} GB`;
  }
  return "";
}
